import { get,post } from "@/request/http";
import encrypt from "@/plugins/encrypt";

// 显示虚拟项目列表
export { showVirtualSimulation } from "../public/virtualExp";

export const getFontendNewsList = p =>
    post("/center/getFontendNewsList", {
        params: encrypt(p)
    });
    // get("http://l.mools.net/index.php/center/getFontendNewsList", p);

export const getFontendNoticeList = p =>
    post("/center/getFontendNoticeList", {
        params: encrypt(p)
    });
    // get("http://l.mools.net/index.php/center/getFontendNoticeList", p);
// export const getBanner = p =>
//  get("http://l.mools.net/index.php/center/getBanner", p);
//  get("http://localhost:8081/index.php/center/getBanner",p)
    


